import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models/ServiceResponse'

export interface ICompetitionType {
  id: number;
  name: string;
  description?: string;
}

export class CompetitionTypeApiService extends ApiService {
  static async getAll(): Promise<IServiceResponse<ICompetitionType[]>> {
    return this.axios.get('competition-types')
      .then((response: AxiosResponse<IServiceResponse<ICompetitionType[]>>) => response.data)
  }
}
